var ubian = ubian || {};

ubian.utils = {};
/**
 * format price or return integer/fractional part of price
 * @param {Number/String} number number to be formatted
 * @param {String} part if not provided, returns number in format XXX,YY
 * <br>"int|integer|whole" - return integer part of number, ie XXX from XXX.YY
 * <br>"frac|fractional|fraction" - return fractional part of number, ie YY from XXX.YY
 * @returns {ubian.utils.price.parts}
 */
ubian.utils.price = function (number, part) {
  if (typeof number !== "number") {
    number = parseFloat(number);
  }
  var formatted = number.toFixed(2);
  if (typeof part === "undefined") {
    part = "no-format";
  }
  var parts = formatted.split(".");
  switch (part) {
    case "int":
    case "integer":
    case "whole":
      return parts[0];
    case "frac":
    case "fractional":
    case "fraction":
      return parts[1];
    default:
      return formatted.replace(".", ",");
  }
};
/**
 * display generic alert window
 * @param {String} text text of alert
 * @param {String} title title of alert, none if not provided
 * @param {String} buttonLabel label of button, OK if not provided
 * @returns {Object} returns instance of dialog
 */
ubian.utils.alert = function (
  text,
  title,
  buttonLabel,
  onClose,
  noDismiss,
  windowClass
) {
  if (typeof title === "undefined" || title === null) {
    title = "";
  }
  if (typeof buttonLabel === "undefined" || buttonLabel === null) {
    buttonLabel = ubian.translate("Button.OK");
  }
  if (typeof noDismiss === "undefined") {
    noDismiss = true;
  }
  var dialog =
    '<div class="modal modal-base modal-alert ' +
    (windowClass ? windowClass : "") +
    '" role="dialog">' +
    '<div class="modal-dialog">' +
    '<div class="modal-content">' +
    '<div class="modal-body">' +
    "<h2>%title%</h2>" +
    (noDismiss
      ? ""
      : '<button type="button" class="close js-close-modal" data-dismiss="modal">&times;</button>') +
    "%body%" +
    '<br><br><div class="buttons">' +
    '<a href="#" class="btn btn-green js-confirm-btn" data-dismiss="modal">%buttonLabel%</a>' +
    "</div>" +
    "</div>" +
    "</div>" +
    "</div>" +
    "</div>";
  dialog = $(
    dialog
      .replace("%title%", title)
      .replace("%body%", text)
      .replace("%buttonLabel%", buttonLabel)
  );
  $(dialog).modal({ backdrop: "static" });
  if (typeof onClose !== "undefined" && onClose) {
    $(dialog).one("click", ".js-confirm-btn", {}, function () {
      onClose();
    });
    // $(dialog).on("hide.bs.modal", function (e) {
    //   onClose();
    // });
  }
  return dialog;
};
/**
 * show confirmation dialog
 * @param {string} text
 * @param {string} title
 * @param {string} buttonLabel
 * @param {string} buttonUrl
 * @returns {String|ubian.utils.confirm.dialog}
 */
ubian.utils.confirm = function (text, title, buttonLabel, buttonUrl) {
  if (typeof title === "undefined") {
    title = "";
  }
  if (typeof buttonLabel === "undefined") {
    buttonLabel = ubian.translate("Button.OK");
  }
  var dialog =
    '<div class="modal modal-base modal-alert fade" role="dialog">' +
    '<div class="modal-dialog">' +
    '<div class="modal-content">' +
    '<div class="modal-body">' +
    "<h2>%title%</h2>" +
    /*'<button type="button" class="close" data-dismiss="modal">&times;</button>' +*/
    "%body%" +
    '<br><br><div class="buttons">' +
    '<a href="#" class="btn btn-transparent-gray" data-dismiss="modal">' +
    ubian.translate("Button.Cancel") +
    "</a> " +
    '<a href="%buttonUrl%" class="btn btn-green">%buttonLabel%</a>' +
    "</div>" +
    "</div>" +
    "</div>" +
    "</div>" +
    "</div>";
  dialog = dialog
    .replace("%title%", title)
    .replace("%body%", text)
    .replace("%buttonLabel%", buttonLabel)
    .replace("%buttonUrl%", buttonUrl);
  $(dialog).modal();
  return dialog;
};

ubian.utils.confirmDialog = function (
  text,
  title,
  buttonOk,
  cbOk,
  buttonCancel,
  cbCancel,
  dismiss,
  cbDismiss,
  btnsInRows
) {
  if (!title) {
    title = "";
  }
  if (!buttonOk) {
    buttonOk = ubian.translate("Button.OK");
  }
  if (!buttonCancel) {
    buttonCancel = ubian.translate("Button.Cancel");
  }
  var dialog =
    '<div class="modal modal-base modal-alert fade modal-confirm" role="dialog" data-backdrop="static" data-keyboard="false">' +
    '<div class="modal-dialog">' +
    '<div class="modal-content">' +
    '<div class="modal-body">' +
    "<h2>%title%</h2>" +
    /*(dismiss ? '<button type="button" class="close js-disclose-btn">&times;</button>' : '') +*/
    "%body%" +
    '<br><br><div class="buttons"' + (btnsInRows === true ? 'style="display: flex; flex-direction: column-reverse;"' : '') + '>' +
    '<a  class="' + (btnsInRows === true ? '' : 'btn btn-transparent-gray') + ' js-confirm-btn-cancel" data-dismiss="modal"' + (btnsInRows === true ? 'style="color: black; padding: 10px 0;font-weight: bold;"' : '') + '>' +
    buttonCancel +
    "</a> " +
    '<a class="btn btn-green js-confirm-btn-ok"' + (btnsInRows === true ? 'style="width: 100%;"' : '') + '>' +
    buttonOk +
    "</a>" +
    "</div>" +
    "</div>" +
    "</div>" +
    "</div>" +
    "</div>";
  $dialog = $(dialog.replace("%title%", title).replace("%body%", text));
  $dialog.modal();
  $(document).off("click", ".js-confirm-btn-ok");
  $(document).off("click", ".js-confirm-btn-cancel");
  $(document).one("click", ".js-confirm-btn-ok", {}, function () {
    $dialog.modal("hide");
    if (cbOk) {
      cbOk();
    }
  });

  $(document).one("click", ".js-disclose-btn", {}, function () {
    $dialog.modal("hide");
    if (cbDismiss) {
      cbDismiss();
    }
  });

  $(document).one("click", ".js-confirm-btn-cancel", {}, function () {
    $dialog.modal("hide");
    if (cbCancel) {
      cbCancel();
    }
  });

  return dialog;
};
/**
 * stringify object
 * @param {type} i
 * @param {type} level
 * @return {String|undefined}
 */
ubian.utils.stringify = function (i, level) {
  var v = JSON.parse(JSON.stringify(i));
  var out = "";
  var levelStr = "";
  if (!level) {
    out =
      '<div style="text-align: left;font-family: monospace;font-size: 10px">';
    level = 0;
  } else {
    out = "<br />";
    levelStr = "&nbsp;".repeat(level) + "└ ";
  }
  if (typeof v !== "object") {
    return v;
  }
  for (prop in v) {
    out =
      out +
      "<b>" +
      levelStr +
      prop +
      ":</b>" +
      ubian.utils.stringify(v[prop], level + 1) +
      "<br />";
  }
  if (!level) {
    out += "</div>";
  }
  return out;
};
/**
 * return whether view is considered mobile
 * @return {unresolved}
 */
ubian.utils.isMobile = function () {
  return $(".visible-mobile").first().is(":visible");
};

/**
 * log of tracking events
 * @type {Array}
 */
ubian.utils.trackLog = [];

/**
 * track events
 * @param {String} name name of event to track
 * @return {void}
 */
ubian.utils.track = function (name) {
  var cookieConsent = Cookies.get(ubian.cookieConsent.cookieName);
  if (cookieConsent !== undefined && cookieConsent.includes("analytics.1")) {
    var event = { time: new Date().getTime(), name: name, args: arguments };
    ubian.utils.trackLog.push(event);
    var gaEvent = {};
    if (arguments.length > 1) {
      gaEvent.event_category = arguments[1];
    }
    if (arguments.length > 2) {
      gaEvent.event_label = arguments[2];
    }
    if (typeof gtag != 'undefined') {
      gtag("event", name, gaEvent);
    }
  }
};

var track = ubian.utils.track;

/**
 * return loader html code
 * @returns {String}
 */
ubian.utils.loader = function () {
  return '<div class="ui-loader-icon loader-icon js-loader-icon"><span></span></div>';
};

ubian.utils.removeLoader = function () {
  $(".js-loader-icon").remove();
};

ubian.utils.fullscreenProgress = function (content) {
  var progress = $(
    '<div class="js-fullscreen-progress" style="background-color:rgba(0,0,0,0.8);position: fixed;left:0;top:0;height:100%; width:100%; z-index: 100; display: flex; align-items: center; justify-content: center"><div style="color:#fff; font-weight: bold;">' +
    (content || ubian.utils.loader()) +
    "</div></div>"
  );
  $("body").append(progress);
};
ubian.utils.removeFullscreenProgress = function () {
  $(".js-fullscreen-progress").remove();
};

/**
 * validate email address
 */
ubian.utils.validateEmail = function (email) {
  if (
    /[a-zA-Z0-9\-_+.]+@[a-zA-Z0-9\-_+.]+\.[a-zA-Z\-_+.]+/.test(email) === false
  ) {
    return false;
  }
  return true;
};

/**
 * validate phone number
 */
ubian.utils.validatePhoneNumber = function (phone) {
  if (/^[+]{0,1}[0-9]{10,15}$/.test(phone) === false) {
    return false;
  }
  return true;
};
